/**
 * Turns a text body returned by the API (for example a CSV) into a browser download.
 *
 * API.call parses responses as text, so the body arrives as a string; wrapping it in a
 * Blob here keeps the download logic out of reducers (see dtrMultiLogsSummaryReducers for
 * the older inline pattern this replaces for new screens).
 */
export const downloadTextFile = (body, filename, mimeType = "text/csv;charset=utf-8;") => {
  const blob = new Blob([body], { type: mimeType });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  if (typeof window.URL.revokeObjectURL === "function") {
    window.URL.revokeObjectURL(url);
  }
};

export default { downloadTextFile };
